// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.vectorizer=NEXT_PUBLIC_RPC_VECTORIZER_URL,service.creativefabrica.social=NEXT_PUBLIC_RPC_SOCIAL_URL,service.creativefabrica.uploads=NEXT_PUBLIC_RPC_UPLOADS_URL,service.creativefabrica.studio=NEXT_PUBLIC_RPC_STUDIO_URL,service.creativefabrica.content=NEXT_PUBLIC_RPC_CONTENT_URL,service.creativefabrica.studiofeed=NEXT_PUBLIC_RPC_STUDIOFEED_URL,include.creativefabrica.vectorizer.v2.VectorizerService.List=infiniteQuery,include.creativefabrica.social.v2.SocialService.GetUserFeaturedImages=query,include.creativefabrica.social.v2.SocialService.ListImageLibrary=query,include.creativefabrica.social.v2.SocialService.SelectFeaturedImages=mutation,include.creativefabrica.social.v2.SocialService.CreateSignedUrl=mutation,include.creativefabrica.social.v2.SocialService.PostProductProject=mutation,include.creativefabrica.social.v2.SocialService.ListAssets=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMachines=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMaterials=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListThemes=infiniteQuery,include.creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl=mutation,include.creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload=mutation,include.creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload=mutation,include.creativefabrica.studio.v2.StudioService.GetUserBanStatus=query,include.creativefabrica.content.v2.MarketplaceService.GetHomepageProductRecommendations=query,include.creativefabrica.studiofeed.v1.TemplateService.ListTemplates=query"
// @generated from file creativefabrica/uploads/v2/service.proto (package creativefabrica.uploads.v2, syntax proto3)
/* eslint-disable */

import type { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient } from "@connectrpc/connect";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { UploadsService, CreateDirectVoDUploadUrlResponse, CreateDirectVoDUploadUrlRequestSchema, InitiateVoDMultipartUploadResponse, InitiateVoDMultipartUploadRequestSchema, CompleteVoDMultipartUploadResponse, CompleteVoDMultipartUploadRequestSchema } from "./service_pb";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the UploadsService service
 * Service: creativefabrica.uploads.v2.UploadsService
 */

invariant(process.env.NEXT_PUBLIC_RPC_UPLOADS_URL, 'NEXT_PUBLIC_RPC_UPLOADS_URL env var is not set within gen/service/creativefabrica/creativefabrica/uploads/v2/service_pb.ts. Please make sure the env var is available to your project/script/app.')

const UploadsServiceTransport = createConnectTransport({
  baseUrl: process.env.NEXT_PUBLIC_RPC_UPLOADS_URL,
  useBinaryFormat: false,
  interceptors,
})

const UploadsServiceClient = createClient(
  UploadsService,
  UploadsServiceTransport,
)

/**
 * Unique identifier for the CreateDirectVoDUploadUrl mutation
 */
export const CreateDirectVoDUploadUrlMutationKey = 'UploadsService.CreateDirectVoDUploadUrl' as const;

/**
 * @generated from rpc creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl
 */
/**
 * Function to execute the CreateDirectVoDUploadUrl RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function createDirectVoDUploadUrlFn(variables: MessageInitShape<typeof CreateDirectVoDUploadUrlRequestSchema>, meta?: Record<string, unknown>): Promise<CreateDirectVoDUploadUrlResponse> {
  return UploadsServiceClient.createDirectVoDUploadUrl(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl
 */
export function useCreateDirectVoDUploadUrlMutation(options?: Omit<
  UseMutationOptions<
    CreateDirectVoDUploadUrlResponse,
    Error,
    MessageInitShape<typeof CreateDirectVoDUploadUrlRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    CreateDirectVoDUploadUrlResponse,
    Error,
    MessageInitShape<typeof CreateDirectVoDUploadUrlRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => createDirectVoDUploadUrlFn(variables, options?.meta),
    mutationKey: [CreateDirectVoDUploadUrlMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the InitiateVoDMultipartUpload mutation
 */
export const InitiateVoDMultipartUploadMutationKey = 'UploadsService.InitiateVoDMultipartUpload' as const;

/**
 * @generated from rpc creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload
 */
/**
 * Function to execute the InitiateVoDMultipartUpload RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function initiateVoDMultipartUploadFn(variables: MessageInitShape<typeof InitiateVoDMultipartUploadRequestSchema>, meta?: Record<string, unknown>): Promise<InitiateVoDMultipartUploadResponse> {
  return UploadsServiceClient.initiateVoDMultipartUpload(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload
 */
export function useInitiateVoDMultipartUploadMutation(options?: Omit<
  UseMutationOptions<
    InitiateVoDMultipartUploadResponse,
    Error,
    MessageInitShape<typeof InitiateVoDMultipartUploadRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    InitiateVoDMultipartUploadResponse,
    Error,
    MessageInitShape<typeof InitiateVoDMultipartUploadRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => initiateVoDMultipartUploadFn(variables, options?.meta),
    mutationKey: [InitiateVoDMultipartUploadMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the CompleteVoDMultipartUpload mutation
 */
export const CompleteVoDMultipartUploadMutationKey = 'UploadsService.CompleteVoDMultipartUpload' as const;

/**
 * @generated from rpc creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload
 */
/**
 * Function to execute the CompleteVoDMultipartUpload RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function completeVoDMultipartUploadFn(variables: MessageInitShape<typeof CompleteVoDMultipartUploadRequestSchema>, meta?: Record<string, unknown>): Promise<CompleteVoDMultipartUploadResponse> {
  return UploadsServiceClient.completeVoDMultipartUpload(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload
 */
export function useCompleteVoDMultipartUploadMutation(options?: Omit<
  UseMutationOptions<
    CompleteVoDMultipartUploadResponse,
    Error,
    MessageInitShape<typeof CompleteVoDMultipartUploadRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    CompleteVoDMultipartUploadResponse,
    Error,
    MessageInitShape<typeof CompleteVoDMultipartUploadRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => completeVoDMultipartUploadFn(variables, options?.meta),
    mutationKey: [CompleteVoDMultipartUploadMutationKey],
    ...options,
  });
}


